import { createContext } from 'react';

const context = createContext(null);

export default context;
